<template>
  <v-dialog
      v-model="openModal"
      :persistent="persistent"
      v-bind="$attrs"
      max-width="650px"
  >
    <v-card class="round">
      <v-toolbar
          dark
          :color="color"
          dense
      >
        <v-row no-gutters align="center">
          <v-col no-gutters cols="2">
            <v-btn
                small
                icon
                dark
                class="ma-3"
                @click="openModal = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>

          <v-col no-gutters cols="8" align-self="center"
          >
            <v-row no-gutters justify="center">
              <v-toolbar-title>
                <slot name="header" />
              </v-toolbar-title>
            </v-row>
          </v-col>
          <v-col no-gutters cols="2">
          </v-col>
        </v-row>

      </v-toolbar>
      <v-card-text>
        <slot />
      </v-card-text>
      <v-card-actions v-if="hasActionSlot">
        <v-spacer />
        <slot name="action" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    value: { type: Boolean },
    persistent: { type: Boolean, default: false },
    color: { type: String, default: 'main_pink' }
  },
  data() {
    return {};
  },
  computed: {
    hasActionSlot() {
      return !!this.$slots.action;
    },
    openModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped>
.round {
  border-radius: 30px;
}
</style>
